import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { WalletCardDownloadProps } from './WalletCardDownload.types'
import { useWalletCardDownload } from './WalletCardDownload.logic'

const WalletCardDownload: React.FC<WalletCardDownloadProps> = (props) => {
  const { appleWalletUrl, webWalletUrl } = useWalletCardDownload(props)

  return (
    <Box textAlign="center" px={{ xs: 2, sm: 0 }}>
      <Typography variant="h2" gutterBottom>
        Your wallet card is ready!
      </Typography>

      <Typography variant="body1" paragraph maxWidth="60ch">
        Choose your preferred digital wallet format below to download your
        medical device wallet card, or view it directly in your browser.
      </Typography>

      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={2}
        mt={6}
        flexWrap="wrap"
        sx={{
          '@media (max-width: 600px)': {
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          },
        }}
      >
        <a
          href={appleWalletUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wallet-card-download-button"
        >
          <img height="40" src="/apple-wallet-icon.svg" alt="Apple Wallet" />
        </a>
        <a
          href={appleWalletUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="wallet-card-download-button"
        >
          <img height="42" src="/google-wallet-icon.svg" alt="Google Wallet" />
        </a>
        {webWalletUrl && (
          <Button
            href={webWalletUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            sx={{
              backgroundColor: '#000',
              color: 'white',
              borderRadius: '6px',
              padding: '6px 12px',
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              minWidth: '120px',
              height: '36px',
              '&:hover': {
                backgroundColor: '#333',
              },
            }}
            startIcon={
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                <path d="M2 12h20" />
              </svg>
            }
          >
            View on Web
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default WalletCardDownload
